import * as types from '../constants'
import { Record, List } from 'immutable'

const MAX_PRICE = 0
const MAX_AREA = 0
const filtersRecord = Record({
  visible: false,
  propertyTypes: new List(),
  propertyTypesSelected: new List(),
  priceMinimum: 0,
  priceMaximum: MAX_PRICE,
  numberOfBedrooms: 0,
  numberOfBathrooms: 0,
  homeTypes: new List(),
  homeTypesSelected: new List(),
  isFilterApplied: false,
  error: null,
  sortBy: 'distance',
  sortOrder: 'asc',
  areaMinimum: 0,
  areaMaximum: MAX_AREA,
  filterTypes: new List(),
})

const initialState = new filtersRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_FILTERS: {
      const {
        propertyTypesSelected,
        priceMinimum,
        priceMaximum,
        numberOfBedrooms,
        numberOfBathrooms,
        homeTypesSelected,
        areaMaximum,
        areaMinimum,
      } = action.filters
      let isFilterApplied = !!(
        homeTypesSelected.length ||
        propertyTypesSelected.length ||
        numberOfBedrooms ||
        numberOfBathrooms ||
        priceMinimum ||
        priceMaximum !== MAX_PRICE ||
        areaMinimum ||
        areaMaximum !== MAX_AREA
      )
      return state.merge({
        propertyTypesSelected,
        priceMinimum,
        priceMaximum,
        numberOfBedrooms,
        numberOfBathrooms,
        homeTypesSelected,
        areaMinimum,
        areaMaximum,
        isFilterApplied,
      })
    }
    case types.FETCH_FILTERTYPES_SUCCESS: {
      return state.set('filterTypes', action.filterTypes)
    }
    case types.FETCH_FILTERTYPES_ERROR: {
      return state.set('error', action.error)
    }
    case types.TOGGLE_FILTERS: {
      return state.set('visible', action.isForceClose ? false : !state.visible)
    }
    case types.SORTING: {
      return state.merge({
        sortBy: action.sortBy,
        sortOrder: action.sortOrder,
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filters.js